import { useMetaState } from '../coraWebComponents/meta/MetaStateContext';


const AkcContainer = ({ akc, primaryField, showMsg, obj }) => {
  const state = useMetaState();

  const props = {
    primaryField: primaryField,
    selected: state[primaryField].selected || [],
    printItems: state[primaryField].printItems || [],
    data: state[primaryField].data || [],
    detailData: state[primaryField].detailData,
    gridSchema: state.gridSchema || [],
    showMsg,
    obj,
    state
  };

  switch (akc.IAkc) {    
    default:
      return null;   
  }
}

const akcFactory = (akc, primaryField, showMsg, obj) => {
  if (!([53,54].includes(akc.IAkc) || akc.IAkc > 1000)) return null;

  return <AkcContainer akc={akc} primaryField={primaryField} db={obj.db} showMsg={showMsg} obj={obj} />;
};


export default akcFactory;
